const PLAN_COVERS = {
    "ai foundations": "/images/plans/ai-foundations.jpg",
    "python for ai": "/images/plans/python-for-ai.jpg",
    "java oop kickstart": "/images/plans/java-oop.jpg",
    "web development mastery": "/images/plans/web-dev.jpg",
    "blockchain & smart contracts": "/images/plans/blockchain.jpg",
    "data science explorer": "/images/plans/data-science.jpg",
    "technical english": "/images/plans/technical-english.jpg",
    "wisdom academy core path": "/images/plans/core-path.jpg",
};

const CERT_COVERS = {
    "ai foundations": "/images/certs/ai-foundations.jpg",
    "python for ai": "/images/certs/python-for-ai.jpg",
    "java oop practitioner": "/images/certs/java-oop.jpg",
    "full-stack web developer": "/images/certs/web-dev.jpg",
    "blockchain builder": "/images/certs/blockchain.jpg",
    "data science explorer": "/images/certs/data-science.jpg",
    "technical writer": "/images/certs/technical-english.jpg",
    "wisdom academy graduate": "/images/certs/core-path.jpg",
    "machine learning associate": "/images/plans/ai-foundations.jpg",
};

const CATEGORY_COVERS = {
    "ai": "/images/plans/ai-foundations.jpg",
    "programming languages": "/images/plans/java-oop.jpg",
    "blockchain": "/images/plans/blockchain.jpg",
    "languages": "/images/plans/technical-english.jpg",
};

export const CERT_SEAL = "/images/certs/seal.jpg";
export const DEFAULT_COVER = "/images/default-course.jpeg";

function keyOf(value) {
    return String(value || "").trim().toLowerCase();
}

export function coverForPlan(plan) {
    if (!plan) {
        return DEFAULT_COVER;
    }
    if (plan.imageurl) {
        return plan.imageurl;
    }
    return PLAN_COVERS[keyOf(plan.title)]
        || CATEGORY_COVERS[keyOf(plan.categoryName || plan.category?.name)]
        || DEFAULT_COVER;
}

const BADGE_COVERS = {
    "getting started": "/images/badges/getting-started.jpg",
    "one week streak": "/images/badges/streak.jpg",
    "two week streak": "/images/badges/streak.jpg",
    "early bird": "/images/badges/bird.jpg",
    "comeback kid": "/images/badges/comeback.jpg",
    "fast learner": "/images/badges/speed.jpg",
    "mastermind": "/images/badges/master.jpg",
    "wisdom seeker": "/images/badges/wisdom.jpg",
    "feedback hero": "/images/badges/community.jpg",
    "feedback pioneer": "/images/badges/community.jpg",
    "first comment": "/images/badges/community.jpg",
    "community helper": "/images/badges/community.jpg",
    "answer champion": "/images/badges/community.jpg",
    "power hour": "/images/badges/time.jpg",
    "mentor joined": "/images/badges/mentor.jpg",
    "session host": "/images/badges/mentor.jpg",
    "ai explorer": "/images/badges/ai.jpg",
    "code wizard": "/images/badges/code.jpg",
    "blockchain beginner": "/images/badges/chain.jpg",
    "frontend first": "/images/badges/frontend.jpg",
    "course author": "/images/badges/author.jpg",
    "plan author": "/images/badges/author.jpg",
};

export function coverForBadge(badge) {
    if (!badge) {
        return "/images/badges/wisdom.jpg";
    }
    const fromApi = badge.iconurl || badge.iconUrl;
    if (fromApi && !String(fromApi).startsWith("/icons/")) {
        return fromApi;
    }
    return BADGE_COVERS[keyOf(badge.title || badge.name)] || "/images/badges/wisdom.jpg";
}

export function coverForCert(cert) {
    if (!cert) {
        return CERT_SEAL;
    }
    const fromApi = cert.imageurl || cert.imageUrl;
    if (fromApi) {
        return fromApi;
    }
    const title = cert.coursetitle || cert.courseTitle || cert.title;
    return CERT_COVERS[keyOf(title)] || CERT_SEAL;
}

export function coverForCourse(course) {
    if (!course) {
        return DEFAULT_COVER;
    }
    const existing = course.imageurl || course.courseimage;
    if (existing) {
        return existing;
    }
    const title = keyOf(course.title || course.coursetitle);
    const category = keyOf(course.category?.name);
    if (title.includes("python")) {
        return "/images/plans/python-for-ai.jpg";
    }
    if (title.includes("java") || title.includes("spring")) {
        return "/images/plans/java-oop.jpg";
    }
    if (title.includes("blockchain") || title.includes("solidity")) {
        return "/images/plans/blockchain.jpg";
    }
    if (title.includes("web") || title.includes("react") || title.includes("full-stack")) {
        return "/images/plans/web-dev.jpg";
    }
    if (title.includes("english") || title.includes("writing")) {
        return "/images/plans/technical-english.jpg";
    }
    if (title.includes("machine") || title.includes("ai:") || title.includes("prompt") || category === "ai") {
        return "/images/plans/ai-foundations.jpg";
    }
    return CATEGORY_COVERS[category] || DEFAULT_COVER;
}
